<template>
  <div ref='viewer'></div>
</template>

<script>
/* eslint-disable */
import WebViewer from '@pdftron/webviewer'
export default {
  name: 'WebViewer',
  props: {
    path: String,
    url: String
  },
  mounted: function () {
        WebViewer({
            path: this.path,
            initialDoc: this.url, // replace with your own PDF file
            fullAPI: true,
          }, this.$refs.viewer).then((instance) => {
            // call apis here
            // instance.disableElements(['ribbons']);
            instance.disableElements(['toolsHeader']);

            instance.disableElements(['toolbarGroup-Shapes']);
            instance.disableElements(['toolbarGroup-Edit']);
            instance.disableElements(['toolbarGroup-Insert']);
            instance.disableElements(['toolbarGroup-Annotate']);
            instance.disableElements(['viewControlsButton', 'viewControlsOverlay']);
            // remove left panel and left panel button from the DOM
            instance.disableElements([ 'leftPanel', 'leftPanelButton', 'toggleNotesButton', 'searchButton' ]);

          });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  height: 400px;
}
</style>